import { useContext, useMemo } from 'react';
import { CssBaseline, createTheme, ThemeProvider } from '@mui/material';
import { deepmerge } from '@mui/utils';
import { ThemeModeContext } from '../providers/ThemeModeProvider';
import { ThemeSchemeContext } from '../providers/ThemeSchemeProvider';
import { getMUIPalette } from '../utils/getMUIPalette';
import { getMUIComponents } from '../utils/getMUIComponents';
import { getMUITypography } from '@M3/utils/getMUITypography';
import { useTranslation } from 'react-i18next';

interface M3Props {
    children?: React.ReactNode;
}

const M3Theme = ({ children }: M3Props) => {
    const { themeMode } = useContext(ThemeModeContext);
    const { themeScheme } = useContext(ThemeSchemeContext);
    const { i18n } = useTranslation();

    const m3Theme = useMemo(() => {
        const muiPalette = getMUIPalette(themeMode, themeScheme);
        const muiTypography = getMUITypography(themeMode, themeScheme);

        let theme = createTheme({ ...muiPalette, ...muiTypography });
        theme = deepmerge(theme, getMUIComponents(theme));

        return theme;
    }, [themeMode, themeScheme]);

    return (
        <ThemeProvider theme={m3Theme}>
            <CssBaseline enableColorScheme />
            {children}
        </ThemeProvider>
    );
};

export default M3Theme;
